// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import { difference } from "lodash"
import { put, select, takeLatest } from "redux-saga/effects"

import { calculateDistanceOn, distanceInMetersBetween, nearest } from "../../common/locationSupport"
import { MAP_DEFAULT_CENTER, MAP_DEFAULT_ZOOM } from "../PropertiesMap"

import { HOME_UPDATE_MAP_PROPS } from "./constants"
import { fetchLgDetail, LG_DETAIL_CACHING } from "./fetchLgDetail"

export function updateMapProps(changes) {
  return {
    type: HOME_UPDATE_MAP_PROPS,
    data: changes,
  }
}

// worker Saga: will be fired on HOME_UPDATE_MAP_PROPS actions
export function* doUpdateMapProps() {
  const { authToken, fetchLgDetailPending, lhoData, protectedRefs } = yield select(state => {
    const { authToken } = state.auth
    const { unsentCases } = state.damageCase
    const { fetchLgDetailPending, lhoData } = state.home
    const protectedRefs = Object.values(unsentCases).map(damageCase => damageCase.lhoRef.split(".")[0])
    return { authToken, fetchLgDetailPending, lhoData, protectedRefs }
  })

  if (authToken && lhoData) {
    const nearestRefs = nearest(LG_DETAIL_CACHING.maxFetch, lhoData.properties).map(p => p.reference)
    const wantedRefs = nearestRefs.concat(protectedRefs).sort()
    const refsToFetch = difference(wantedRefs, fetchLgDetailPending)

    if (refsToFetch.length > 0) {
      yield put(fetchLgDetail(authToken, refsToFetch))
    }
  }
}

/*
  Alternatively you may use takeEvery.

  takeLatest does not allow concurrent requests. If an action gets
  dispatched while another is already pending, that pending one is cancelled
  and only the latest one will be run.
*/
export function* watchUpdateMapProps() {
  yield takeLatest(HOME_UPDATE_MAP_PROPS, doUpdateMapProps)
}

export function reducer(state, action) {
  switch (action.type) {
    case HOME_UPDATE_MAP_PROPS:
      const changes = action.data

      const newState = {
        ...state,
        mapCenter: changes.center || state.mapCenter,
        zoomLevel: (changes.zoom || state.zoomLevel) + (changes.zoom_in || 0),
      }

      uponMapMovement(state, newState)

      return newState

    default:
      return state
  }
}

export function uponMapMovement(oldState, newState) {
  const oldCenter = oldState.mapCenter
  const newCenter = newState.mapCenter

  if (newCenter) {
    // In case of a significant relocation, recalculate the distances to all properties on the map
    if (oldCenter == null || distanceInMetersBetween(oldCenter, newCenter) > 5) {
      const properties = calculateDistanceOn(newCenter, newState.lhoData.properties)
      newState.lhoData = { ...newState.lhoData, properties: properties }
    }

    // When falling back to the default map center, always fall back to the default zoom level as well
    if (distanceInMetersBetween(newCenter, MAP_DEFAULT_CENTER) < 1) {
      newState.zoomLevel = MAP_DEFAULT_ZOOM
    }
  }
}



// WEBPACK FOOTER //
// ./src/features/home/redux/updateMapProps.js